import React, { useContext, useEffect, useState } from 'react';
import { useFetch } from '../api/useFetch';
import { useUserContext } from './user_context';

export const PackagesContext = React.createContext();


export const PackagesProvider = ({ children }) => {


    const { btoken } = useUserContext();


    let historyData = { btoken };
    const {
        loading: billingHistoryLoading, data: allBillingHistory, fetchData: getBillingHistoryData
    } = useFetch('/subscriptionHistory', historyData);

    let packageData = { btoken };
    const {
        loading: monthlyPackagesLoading, data: allMonthlyPackages, fetchData: getMonthlyPackages
    } = useFetch('/getPackages');

    const {
        loading: yearlyPackagesLoading, data: allYearlyPackages, fetchData: getYearlyPackages
    } = useFetch('/getPackages.year', packageData);

    useEffect(() => {
        getMonthlyPackages();
        getYearlyPackages();
    }, []);


    const [showPayForFree, setShowPayForFree] = useState(false);
    const closePayForFree = () => setShowPayForFree(false);
    const openPayForFree = () => setShowPayForFree(true);

    const [showWalletPayment, setShowWalletPayment] = useState(false);
    const closeWalletPayment = () => setShowWalletPayment(false);
    const openWalletPayment = () => setShowWalletPayment(true);

    return (
        <PackagesContext.Provider value={{

            billingHistoryLoading, allBillingHistory, getBillingHistoryData,

            showPayForFree, closePayForFree, openPayForFree,
            showWalletPayment, closeWalletPayment, openWalletPayment,

            monthlyPackagesLoading, allMonthlyPackages, getMonthlyPackages,
            yearlyPackagesLoading, allYearlyPackages, getYearlyPackages,
        }}>
            {children}
        </PackagesContext.Provider>
    );
};

// make sure use
export const usePackagesContext = () => {
    return useContext(PackagesContext);
};
